import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import { t } from "ttag";
import useStyles from "./DeviceManagement.style";
import { getFirmwareVersionId } from "./firmwareUiUtils";

interface UpgradeFirmwareDialogProps {
  open: boolean;
  firmwareVersion: any;
  currentFirmwareCatalog: any;
  installedFirmwareVersion: string;
  newerFirmwareVersions: any[];
  loadingFirmwareVersions: boolean;
  selectedUpgradeVersion: any;
  isUpgradingFirmware: boolean;
  onClose: () => void;
  onSelectVersion: (value: any) => void;
  onUpgrade: () => void;
}

const UpgradeFirmwareDialog = ({
  open,
  firmwareVersion,
  currentFirmwareCatalog,
  installedFirmwareVersion,
  newerFirmwareVersions,
  loadingFirmwareVersions,
  selectedUpgradeVersion,
  isUpgradingFirmware,
  onClose,
  onSelectVersion,
  onUpgrade,
}: UpgradeFirmwareDialogProps) => {
  const styles: any = useStyles();
  const currentVersionToDisplay =  firmwareVersion || installedFirmwareVersion || "";

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle className={styles.firmwareUpgradeDialogTitle}>
        {t`Update Firmware`}
      </DialogTitle>
      <DialogContent className={styles.firmwareUpgradeDialogContent}>
        <Box className={styles.firmwareVersionWithHelp}>
          <Typography className={styles.firmwareUpgradeCurrentLabel}>
            {t`Current Installed Version`}: <b>{currentVersionToDisplay}</b>
          </Typography>
        </Box>
        <Box className={styles.firmwareUpgradeSelectRow}>
          <Autocomplete
            className={styles.firmwareUpgradeSelect}
            options={newerFirmwareVersions}
            loading={loadingFirmwareVersions}
            value={selectedUpgradeVersion}
            onChange={(_event, value) => onSelectVersion(value)}
            getOptionLabel={(option: any) =>
              option?.isStable
                ? `${option.version} (${t`stable`})`
                : option?.version || ""
            }
            isOptionEqualToValue={(option: any, value: any) =>
              getFirmwareVersionId(option) === getFirmwareVersionId(value)
            }
            noOptionsText={
              loadingFirmwareVersions
                ? t`Loading...`
                : t`No versions found`
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label={t`Choose version`}
                placeholder={t`Select firmware version`}
                variant="outlined"
                fullWidth
              />
            )}
          />
        </Box>
      </DialogContent>
      <DialogActions className={styles.firmwareUpgradeDialogActions}>
        <Button
          className={styles.firmwareUpgradeCancelBtn}
          onClick={onClose}
          disabled={isUpgradingFirmware}
        >
          {t`Cancel`}
        </Button>
        <Button
          type="button"
          variant="contained"
          className={styles.firmwareUpgradeActionBtn}
          disabled={
            !getFirmwareVersionId(selectedUpgradeVersion) || isUpgradingFirmware
          }
          onClick={onUpgrade}
        >
          {isUpgradingFirmware ? (
            <CircularProgress size={20} color="inherit" />
          ) : (
            t`Update Firmware`
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UpgradeFirmwareDialog;
